<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 创建采购需求 -->
<template>
  <div class="my-enquiry container">
    <div class="big-title">采购需求详情</div>
    <!--程序报错，暂时注释掉-->
    <el-form
      ref="formDom"
      :model="detailInfo"
      class="form-content"
      size="small"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label-width="120px" label="需求名称：">
            <span>{{ detailInfo.purchaseDemandName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="产品批号：">
            <span>{{ detailInfo.productBatchNumber }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 基本信息 -->
      <div class="commodity-list">
        <div class="title">基本信息</div>
        <div class="commodity-content" style="padding-bottom: 2px">
          <div class="enquiry-form">
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="需求部门：">
                  <span>{{ detailInfo.orgShortName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="需求申请人：">
                  <span>{{ detailInfo.createMemberName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="关联预算：">
                  <span>{{ detailInfo.budgetName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="概算金额：">
                  <span>{{ budgetaryTotalAmount }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 物料信息 -->
      <div class="commodity-list">
        <div class="title">物料信息</div>
        <div class="commodity-content">
          <!-- table -->
          <e-table-list
            style="margin-top: 20px"
            :index-show="true"
            :loading="loading"
            :table-data="tableData.slice((pageNum - 1) * 10, pageNum * 10)"
            :table-label="tableLabel"
            :reserve-selection="false"
          >
            <template #attachment="slot">
              <div
                v-if="
                  slot.scope.row.purchaseDemandItemAttachmentDetailVOS[0]
                    .attachmentUrl
                "
              >
                <a
                  :href="
                    slot.scope.row.purchaseDemandItemAttachmentDetailVOS[0]
                      .attachmentUrl
                  "
                  :download="
                    slot.scope.row.purchaseDemandItemAttachmentDetailVOS[0]
                      .attachmentName
                  "
                >
                  <i class="el-icon-paperclip"></i>
                </a>
              </div>
            </template>
          </e-table-list>
          <el-pagination
            style="margin-top: 20px"
            class="pagination"
            :pager-count="5"
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="queryData.pageNum"
            :total="queryData.pageTotal"
            :page-size.sync="queryData.pageSize"
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>

      <!-- 备注附件 -->
      <div class="commodity-list">
        <div class="title">备注附件</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="附件：">
                <div>
                  <span
                    v-for="item in showRemarkList"
                    :key="item.attachmentUrl"
                    class="file-name"
                    @click="
                      downloadFile(item.attachmentName, item.attachmentUrl)
                    "
                  >
                    {{ dealAttachmentName(item.attachmentName) }}
                  </span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="142px"
                label="备注："
                aria-placeholder="请输入备注信息"
                prop="remark"
              >
                <span>{{ detailInfo.remark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <!-- 审批流组件-->
    <approval-process
      v-if="approvalData.length > 0"
      :approval-data="approvalData"
    />

    <div class="handle-button">
      <div class="btn back-btn" @click="toBack">< 返回</div>
      <div v-if="isCreate == '1'" class="right-btn">
        <el-button class="btn reset-btn" @click="handleApprove('2')"
          >审批拒绝</el-button
        >
        <el-button class="btn submit-btn" @click="handleApprove('1')"
          >审批通过</el-button
        >
      </div>
    </div>
    <eDialog
      :dialog-type="dialogType"
      :dialog-title="dialogTitle"
      :dialog-content="dialogContent"
      :show-btn="true"
      :center-dialog-visible="visible"
      :popup-width="'600px'"
      @updateVisible="visible = false"
      @resetPopupData="visible = false"
      @submitPopupData="approvePurchaseDemand"
    >
      <div v-if="approveStatus == 1">
        <span
          >您正在操作采购需求审批通过，请详细核对需求信息。
          此操作无法撤销，是否继续？</span
        >
        <div class="line">
          审批意见：
          <el-input
            v-model="contents"
            type="textarea"
            :rows="2"
            placeholder="同意"
            maxlength="300"
            show-word-limit
          ></el-input>
        </div>
      </div>
      <div v-else>
        <span>您正在操作采购需求审批拒绝，此操作无法撤销，是否继续？</span>
        <div class="line">
          <div>拒绝原因：</div>
          <el-input
            v-model="contents"
            type="textarea"
            :rows="2"
            placeholder="请输入拒绝原因"
            maxlength="300"
            show-word-limit
          ></el-input>
        </div>
      </div>
    </eDialog>
  </div>
</template>
<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import eDialog from '@/modules/projectA/components/common/e-dialog';
import approvalProcess from '@/modules/projectA/components/common/approvalProcess.vue';
import stepUtils from '@/modules/projectA/utils/stepUtils';
import Api from '@/modules/projectA/api/auditManagement/index';
import purApi from '@/modules/projectA/api/purchase/index';
import enApi from '@/modules/projectA/api/enquiry/index';
import currency from 'currency.js';

import {
  dealAttachmentName,
  dateformate,
} from '@/modules/projectA/utils/utils';

export default {
  components: { eTableList, eDialog, approvalProcess },
  data() {
    return {
      approvalData: [],
      approveStatus: '',
      visible: false,
      dialogType: '',
      dialogTitle: '',
      dialogContent: '',
      detailInfo: {},
      isCreate: '1',
      pageNum: 1,
      queryData: {
        pageSize: 10,
        pageTotal: 0,
      },
      loading: false,
      tableData: [],
      tableLabel: [
        { label: '物料分类', param: 'categoryName', align: 'center' },
        { label: '物料编码', param: 'categoryCustomCode', align: 'center' },
        { label: '物料描述', param: 'categoryDesc', align: 'center' },
        {
          label: '规格型号',
          param: 'specifications',
          align: 'center',
          width: '80',
        },
        {
          label: '计量单位',
          param: 'baseUnitName',
          align: 'center',
          width: '80',
        },
        { label: '需求数量', param: 'quantity', align: 'center', width: '90' },
        {
          label: '概算单位（元）',
          param: 'budgetaryPrice',
          align: 'center',
          width: '120',
        },
        {
          label: '到货日期',
          param: 'expectedArrivalDate',
          align: 'center',
          render: (row) => {
            return dateformate(row.expectedArrivalDate, 'yyyy年MM月dd日');
          },
        },
        { label: '图号', param: 'imageNumber', align: 'center' },
        { label: '订货方', param: 'buyer', align: 'center' },
        { label: '件号', param: 'partNumber', align: 'center' },
        { label: '标准', param: 'standard', align: 'center' },
        { label: '备注', param: 'remark', align: 'center' },
        {
          label: '附件',
          param: '',
          align: 'center',
          slot: 'attachment',
          width: '90',
        },
      ],
      budgetVisible: false,
      addMaterialVisible: false,

      integratedTableData: [],
      tipsMessage: '支持excel、pdf、word格式文件,小于30M',
      uploadUrl: '',
      zoneId: '',
      // 回显文件
      showFileList: [],
      categoryInfo: {},
      // 头信息
      productDetail: {},
      limit: 1,
      fileSize: 30,
      // 上传需求描述的index
      clickTableIndex: 0,
      // 上传需求描述-弹窗
      materialFileVisible: false,
      enquiryTypeFlag: false,
      addressVisible: false,
      baseUnitNameList: [],
      purchaseDemandId: '',
      purchaseDemandStatus: '',
      showRemarkList: [],
      contents: '',
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.userInfo;
    },
    budgetaryTotalAmount() {
      if (this.detailInfo.purchaseDemandItemDetailVOS.length) {
        // console.log(this.formData.purchaseDemandItemAddAOList);
        let countNum = 0;
        this.detailInfo.purchaseDemandItemDetailVOS.forEach((item) => {
          countNum += currency(item.budgetaryPrice || 0).multiply(
            item.quantity || 0
          ).value;
        });
        this.detailInfo.demandAmount = countNum.toFixed(2);
        return countNum === 0 ? '--' : `${countNum.toFixed(2)}元`;
      }
      return '--';
    },
  },
  mounted() {
    const { purchaseDemandId = '', flag = '' } = this.$route.query;
    this.purchaseDemandId = purchaseDemandId;
    this.isCreate = flag;
    this.queryPurchaseDemandDetail();
  },
  methods: {
    dealAttachmentName,
    downloadFile(fileName, fileUrl) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
    },
    handleSizeChange() {},

    async getBaseUnitName(categoryId) {
      this.baseUnitNameList = [];
      try {
        const result = await Api.selectCategoryUnitList({
          categoryId,
        });
        this.baseUnitNameList = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    toBack(times) {
      if (times) {
        this.$router.push({
          path: '/auditManagement/demand',
          query: { t: times },
        });
      } else {
        this.$router.push({ path: '/auditManagement/demand' });
      }
    },
    handleApprove(approveStatus) {
      this.visible = true;
      this.dialogTitle = approveStatus == 1 ? '审批通过' : '审批拒绝';
      this.dialogType = approveStatus == 1 ? 'success' : 'warning';
      this.approveStatus = approveStatus;
    },
    async approvePurchaseDemand() {
      if (!this.contents && this.approveStatus == '2') {
        return this.$message.error('输入拒绝原因。');
      }
      if (!this.contents && this.approveStatus == '1') {
        this.contents = '同意';
      }

      const params = {
        approveStatus: this.approveStatus,
        businessAuditId: this.businessAuditId,
        purchaseDemandId: this.purchaseDemandId,
        contents: this.contents,
      };
      const res = await Api.approvePurchaseDemanAudit(params);
      if (res.code == '200') {
        this.$message.success(
          this.approveStatus == 1 ? '审批通过成功。' : '审批拒绝成功。'
        );
        this.visible = false;
        this.contents = '';
        setTimeout(() => {
          let times = new Date();
          times = times.getTime();
          this.toBack(times);
        }, 1000);
      }
    },
    async queryPurchaseDemandDetail() {
      const res = await purApi.queryPurchaseDemandDetail({
        purchaseDemandId: this.purchaseDemandId,
      });
      if (res.code == '200') {
        this.detailInfo = res.data;
        this.tableData = res.data.purchaseDemandItemDetailVOS || [];
        this.queryData.pageTotal = this.tableData.length;
        this.showRemarkList = res.data.purchaseDemandAttachmentDetailVOS;
        this.queryAuditBusinessFlowLogList();
      }
    },

    // 获取审批流数据
    async queryAuditBusinessFlowLogList() {
      const { companyId } = JSON.parse(localStorage.getItem('USERINFO'));
      const params = {
        companyId,
        businessId: this.$route.query.purchaseDemandId,
        businessAuditType: 3, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标
      };
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200' && res.data.length > 0) {
        const data = res.data || [];

        // 封装发起审批人数据
        const firstData = {
          step: '发起审批',
          icon: require('@/assets/img/approval/fqsp.png'),
          auditStatus: 1,
          nodeMember: {
            auditMemberPhone: this.detailInfo.mobile,
            auditMemberName: this.detailInfo.createMemberName,
            approveTime: this.detailInfo.createTime,
          },
        };

        // 封装发起审批 的数据 插入第一条
        data.unshift(firstData);
        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.my-enquiry {
  background: #fff;
  .big-title {
    color: #333;
    font-weight: bold;
    font-size: 16px;
    margin: 0 0 20px 10px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }

  .validate-table {
    ::v-deep .el-table__row td {
      padding: 8px 0 0 0;
    }
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #2587ff;
    background: #2587ff;
  }

  ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #2587ff;
  }

  .line {
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
  .search-form {
    display: flex;
    .el-input {
      width: 200px;
    }
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }

    .sp-radio {
      margin: 10px 0 0 0;
      ::v-deep .el-radio {
        position: relative;
        margin-right: 60px;
      }
    }

    .left-icon {
      position: absolute;
      left: 96px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
    .right-icon {
      position: absolute;
      left: 236px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }

  .commodity-list {
    border: 1px solid #f5f5f5;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding-left: 20px;
    }
    .commodity-content {
      padding: 0 10px 10px 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin-top: 10px;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        margin-top: 10px;
        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }

      .table-handle-btn {
        color: #0064c8;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .err-btn {
        color: #f0250f;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .add-table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }
    .enquiry-form {
      padding-top: 20px;
      .file-name {
        margin-right: 10px;
        color: #0064c8;
        cursor: pointer;
      }
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
      border-radius: 0;
      padding: 0;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
}
</style>
